export const RiskFieldLabels = {
  title: 'Title',
  relatedHazard: 'Mitigation',
  hazardSituation: 'Hazard Situation',
  potentialHarm: 'Potential Harm',
  potentialCauses: 'Potential Cause',
  category: 'Category',
  relevance: 'Relevance',
  currentControls: 'Current Controls',
  residualRisk: 'Residual Risk',
  recommendedActions: 'Recommended Actions',
  actionsTaken: 'Actions Taken',
  verification: 'Verification',
  p1: 'P1',
  s1: 'S2',
  d1: 'D1',
  p2: 'P2',
  s2: 'S2',
  d2: 'D2',
  assignTask: 'Assign Task',
  attachment: 'Attachments',
  taskFiles: 'Document References',
  assignUserNeeds: 'Assign User Needs',
  assignDesignInputs: 'Assign Design Inputs',
  assignDesignOutputs: 'Assign Design Outputs'
} as const;

export type RiskField = keyof typeof RiskFieldLabels;

export const RiskFields: RiskField[] = Object.keys(
  RiskFieldLabels
) as RiskField[];
